import React from "react";
import clsx from "clsx";

interface CardComponentProps {
    children: React.ReactNode | React.ReactNode[];
    title: string;
    className?: string | boolean;
}

const CardComponentBlackHeader = (props: CardComponentProps) => {
    return (
        <div className={clsx(props.className && props.className, "CardComponentBlackHeader rounded-[10px] shadow-card bg-white")}>
            <div className={"flex flex-col  rounded-[10px] overflow-hidden"}>
                <div className={"header bg-black text-center font-semibold text-sm md:text-xl text-white pt-6 pb-4 px-3 flex flex-col justify-items-center"}>
                    <h2>{props.title}</h2>
                </div>
                <div className={"flex items-center justify-center p-2 xl:p-3 "}>{props.children}</div>
            </div>
        </div>
    );
};

export default CardComponentBlackHeader;
